import { CREATE_APT_TAG } from './constants';
import { TagRecord } from './fetchAptConfig';
import fetchWithRefresh from './fetchWithRefresh';

export type CreateTagBody = Omit<TagRecord, 'tag_id' | 'archive' | 'doctor_oid'>;

export type CreateAptTagResponse = Promise<{
    success: boolean;
    data?: TagRecord;
    error?: string | undefined;
}>;

export default async function createAptTag(
    businessId: string,
    tagRecord: CreateTagBody,
): CreateAptTagResponse {
    const response = await fetchWithRefresh(CREATE_APT_TAG(businessId), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            mode: 'cors',
            credentials: 'include',
        },
        body: JSON.stringify({ ...tagRecord }),
    });

    const res = await response.json();
    return res;
}
